var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Col, CurrencyInput, Form, Row, Text } from "@brushfire/ui";
import { useEffect, useState } from "react";
import Constants from "../../../data/constants";
import Skeleton from "@material-ui/lab/Skeleton";
import WidgetSticky from "../../Helpers/WidgetSticky";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import FormikContextListener from "../../Helpers/FormikContextListener";
import { convertCurrencyStrToDecimal, handleErrors } from "../../../data/helpers";
import { useDispatch } from "react-redux";
import { getAttendeePaymentInfo, putAttendeePayment } from "../../../data/api";
import ReactSelect from "react-select";
import { useIntl } from "react-intl";
import { ProgressBar } from "react-bootstrap";
import { isNil } from "lodash";
import { setPaymentRequiredPayload } from "../../../store/PostAttendeeActions/actions";
import { PaymentPayloadType } from "../../../store/PostAttendeeActions/types";
var MyAttendeePayment = function (_a) {
    var _b;
    var eventData = _a.eventData, attendee = _a.attendee, path = _a.path, kiosk = _a.kiosk, setCurrentAttendee = _a.setCurrentAttendee, attendeeTypeData = _a.attendeeTypeData;
    var _c = __read(useState(), 2), attendeePaymentInfo = _c[0], setAttendeePaymentInfo = _c[1];
    var _d = __read(useState(null), 2), selectedOption = _d[0], setSelectedOption = _d[1];
    var _e = __read(useState(false), 2), showCustomInput = _e[0], setShowCustomInput = _e[1];
    var _f = __read(useState(0), 2), amount = _f[0], setAmount = _f[1];
    var _g = __read(useState(null), 2), paymentError = _g[0], setPaymentError = _g[1];
    var dispatch = useDispatch();
    var intl = useIntl();
    var formatCurrency = function (num) {
        return intl.formatNumber(num, {
            style: "currency",
            currency: eventData.currency,
        });
    };
    var getDisplay = function (x) {
        if (attendeePaymentInfo) {
            var currentDisplayAmount = attendeePaymentInfo.currentDisplayAmount, fullAmount = attendeePaymentInfo.fullAmount, fullDisplayAmount = attendeePaymentInfo.fullDisplayAmount, paymentDisplayAmounts = attendeePaymentInfo.paymentDisplayAmounts;
            var localAttendeePaymentDisplay = paymentDisplayAmounts === null || paymentDisplayAmounts === void 0 ? void 0 : paymentDisplayAmounts.find(function (p) {
                return parseFloat(p.amount) === (x !== null && x !== void 0 ? x : 0);
            });
            var amountToPay = x;
            if (localAttendeePaymentDisplay) {
                amountToPay = localAttendeePaymentDisplay.displayAmount;
            }
            else if (x === fullAmount) {
                amountToPay = fullDisplayAmount;
            }
            if (amountToPay - currentDisplayAmount <= 0) {
                return "Pay nothing. Balance remains at ".concat(formatCurrency(currentDisplayAmount), " of ").concat(formatCurrency(fullDisplayAmount));
            }
            else if (fullDisplayAmount - amountToPay <= 0) {
                return "Pay ".concat(formatCurrency(amountToPay - currentDisplayAmount), ". No remaining balance.");
            }
            else {
                return "Pay ".concat(formatCurrency(amountToPay - currentDisplayAmount), ". Remaining balance: ").concat(formatCurrency(fullDisplayAmount - amountToPay), " of ").concat(formatCurrency(fullDisplayAmount));
            }
        }
        return "";
    };
    var getOptions = function () {
        if (!attendeePaymentInfo)
            return [];
        var currentAmount = attendeePaymentInfo.currentAmount, fullAmount = attendeePaymentInfo.fullAmount, paymentAmounts = attendeePaymentInfo.paymentAmounts;
        var allowedAmounts = paymentAmounts
            .replace("*", "")
            .split("|")
            .map(function (a) { return parseFloat(a.replaceAll(" ", "").replaceAll(",", "")); });
        if (!allowedAmounts.includes(fullAmount))
            allowedAmounts.push(fullAmount);
        var set = allowedAmounts.filter(function (x) { return x <= fullAmount && x > currentAmount; }).sort(function (a, b) { return a - b; });
        var list = set.map(function (x) { return ({
            label: getDisplay(x),
            value: x - currentAmount,
        }); });
        // const list: OptionType[] = set.map((x) => {
        // 	console.log("paymentDisplayAmounts", x, paymentDisplayAmounts);
        // 	const currentDisplayAmount = paymentDisplayAmounts?.find(
        // 		(a) => parseFloat(a.amount).toString() === x.toString()
        // 	);
        // 	return {
        // 		label: getDisplay(currentDisplayAmount?.payAmount ?? 0, currentDisplayAmount?.displayAmount ?? 0),
        // 		value: x - currentAmount,
        // 	};
        // });
        if (list.length < 1) {
            list.push({ label: getDisplay(currentAmount), value: currentAmount });
        }
        if (paymentAmounts.includes("*")) {
            list.push({ label: "Custom Amount", value: undefined });
        }
        return list;
    };
    var options = getOptions();
    useEffect(function () {
        if ((attendee === null || attendee === void 0 ? void 0 : attendee.id) && [Constants.Routes.myAttendeePayments].includes(path)) {
            getAttendeePaymentInfo(attendee.id)
                .then(function (_a) {
                var data = _a.data;
                setAttendeePaymentInfo(data);
            })
                .catch(function (err) {
                handleErrors(err, dispatch, undefined, setPaymentError);
            });
        }
    }, [attendee === null || attendee === void 0 ? void 0 : attendee.id, path]);
    useEffect(function () {
        var _a;
        if ((options === null || options === void 0 ? void 0 : options.length) > 0) {
            setSelectedOption(options[0]);
            setAmount((_a = options[0].value) !== null && _a !== void 0 ? _a : null);
        }
    }, [options === null || options === void 0 ? void 0 : options.length]);
    if (paymentError) {
        return (_jsx(Alert, __assign({ purpose: "danger" }, { children: paymentError })));
    }
    if (!attendee || !attendeePaymentInfo) {
        return (_jsx(WidgetSticky, __assign({ className: "sticky-form", bottomOffset: 75, topOffset: 10, active: true }, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }) })));
    }
    var onSubmit = function (values, formikHelpers) {
        var _a, _b;
        var remainingBalance = attendeePaymentInfo.fullDisplayAmount - attendeePaymentInfo.currentDisplayAmount;
        if (amount) {
            if (values.amount <= remainingBalance) {
                values.amount = amount;
                putAttendeePayment(attendee.id, values)
                    .then(function (res) {
                    if (res.status === 202) {
                        dispatch(setPaymentRequiredPayload({
                            type: PaymentPayloadType.attendeePaymentUpdate,
                            payload: res.data,
                            originalFields: values,
                            summaryText: "You're about to apply a payment toward your attendee in the total amount of ".concat(formatCurrency(res.data.total), "."),
                        }));
                    }
                    else {
                        formikHelpers.resetForm({ values: values });
                    }
                })
                    .catch(function (err) {
                    handleErrors(err, dispatch);
                })
                    .finally(function () {
                    formikHelpers.setSubmitting(false);
                });
            }
            else {
                formikHelpers.setFieldError("custom-payment", "Payments must be less than remaining balance: ".concat(intl.formatNumber(remainingBalance, {
                    style: "currency",
                    currency: (_a = eventData.currency) !== null && _a !== void 0 ? _a : "USD",
                })));
                formikHelpers.setSubmitting(false);
            }
        }
        else {
            formikHelpers.setFieldError("custom-payment", "Payments must be less than remaining balance: ".concat(intl.formatNumber(remainingBalance, {
                style: "currency",
                currency: (_b = eventData.currency) !== null && _b !== void 0 ? _b : "USD",
            })));
            formikHelpers.setSubmitting(false);
        }
    };
    var initialValues = {
        amount: (_b = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) !== null && _b !== void 0 ? _b : 0,
    };
    var currentAttendeePaymentDisplay = attendeePaymentInfo === null || attendeePaymentInfo === void 0 ? void 0 : attendeePaymentInfo.paymentDisplayAmounts.find(function (x) { return (parseFloat(x.amount) - attendeePaymentInfo.currentAmount).toString() === (amount !== null && amount !== void 0 ? amount : 0).toString(); });
    return (_jsx(Form, __assign({ initialValues: initialValues, onSubmit: onSubmit, autoComplete: kiosk ? "new-off" : "on", useUnsavedPrompt: false }, { children: function (_a) {
            var _b, _c;
            var formikContext = _a.formikContext;
            return (_jsxs(_Fragment, { children: [_jsx("small", { children: "The following payment options are available for this attendee type. Please select the amount you would like to pay and click continue." }), _jsx(WidgetFieldset, { children: _jsxs("div", __assign({ className: "pos-relative m-top" }, { children: [_jsx(FormikContextListener, { currentPath: path, path: [Constants.Routes.myAttendeePayments], formikContext: formikContext, active: true, initialValues: initialValues, focusDelay: 500 }), _jsxs("div", { children: [_jsx(ReactSelect, { options: options, name: "allowed-payment-dropdown", value: selectedOption !== null && selectedOption !== void 0 ? selectedOption : null, onBlur: function () {
                                                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldTouched("amount", true);
                                            }, onChange: function (option) {
                                                if (option.value === undefined) {
                                                    setShowCustomInput(true);
                                                    setAmount(0);
                                                    setSelectedOption(option);
                                                }
                                                else {
                                                    setSelectedOption(option);
                                                    setAmount(option.value);
                                                    setShowCustomInput(false);
                                                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue("amount", option.value);
                                                }
                                            }, inputId: "amount", isDisabled: false, isSearchable: false, className: "react-select-container", classNamePrefix: "react-select", "aria-label": "Payment Options", onMenuOpen: function () {
                                                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setStatus(__assign(__assign({}, formikContext.status), { menuOpen: true }));
                                            }, onMenuClose: function () {
                                                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setStatus(__assign(__assign({}, formikContext.status), { menuOpen: false }));
                                            } }), showCustomInput && (_jsx(CurrencyInput, { label: "Custom Price", id: "custom-price", name: "custom-payment", isFieldRequired: true, currency: eventData.currency, onChange: function (e) {
                                                setAmount(convertCurrencyStrToDecimal(e.target.value, intl, eventData.currency));
                                            }, onBlur: function (e) {
                                                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue("amount", convertCurrencyStrToDecimal(e.target.value, intl, eventData.currency));
                                            }, defaultValue: formatCurrency(0), hiddenLabel: true, className: "field w-100" })), !isNil(amount) && attendeePaymentInfo.fullAmount && (_jsx(ProgressBar, { now: parseFloat((((amount + attendeePaymentInfo.currentAmount) /
                                                attendeePaymentInfo.fullAmount) *
                                                100).toFixed(1)), label: "".concat((((amount + attendeePaymentInfo.currentAmount) /
                                                attendeePaymentInfo.fullAmount) *
                                                100).toFixed(1), "%"), srOnly: true, className: "m-top-sm" })), _jsx(Text.Mini, __assign({ className: "d-block ta-center" }, { children: "".concat(formatCurrency(attendeePaymentInfo.fullDisplayAmount -
                                                (currentAttendeePaymentDisplay
                                                    ? (_b = currentAttendeePaymentDisplay === null || currentAttendeePaymentDisplay === void 0 ? void 0 : currentAttendeePaymentDisplay.displayAmount) !== null && _b !== void 0 ? _b : 0
                                                    : !isNil(amount)
                                                        ? amount + attendeePaymentInfo.currentAmount
                                                        : 0)), " of \n\t\t\t\t\t\t\t\t\t\t").concat(formatCurrency((_c = attendeePaymentInfo.fullDisplayAmount) !== null && _c !== void 0 ? _c : 0), " due by ").concat(attendeePaymentInfo.paymentsDue
                                                ? "".concat(intl.formatDate(attendeePaymentInfo.paymentsDue, {
                                                    year: "numeric",
                                                    month: "long",
                                                    day: "numeric",
                                                    weekday: "long",
                                                }), " ").concat(intl.formatTime(attendeePaymentInfo.paymentsDue))
                                                : "event") }))] })] })) })] }));
        } })));
};
export default MyAttendeePayment;
